/**
 * CHA-616 — where the BI upload status and upload log live for a tenant.
 *
 * processBIUpload writes them under tenants/{tenantId}/ (CHA-87 E2a); the root bi_table_status /
 * bi_upload_logs collections are only a temporary compatibility mirror for InMocean and are going away.
 * Every screen reads through these helpers, so the path is written in one place and a missing tenant
 * fails loudly instead of quietly reading tenants/undefined/….
 */
import { collection } from 'firebase/firestore';

export const BI_TABLE_STATUS = 'bi_table_status';
export const BI_UPLOAD_LOGS = 'bi_upload_logs';

function requireBiTenantId(tenantId) {
  const normalized = String(tenantId || '').trim();
  if (!normalized) {
    throw new Error('A tenantId is required to read BI upload status or logs');
  }
  return normalized;
}

export function biTableStatusCollection(db, tenantId) {
  return collection(db, 'tenants', requireBiTenantId(tenantId), BI_TABLE_STATUS);
}

export function biUploadLogsCollection(db, tenantId) {
  return collection(db, 'tenants', requireBiTenantId(tenantId), BI_UPLOAD_LOGS);
}
